import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { RouterPaths } from '../_helpers/router-paths';

export const isMobileGuard = () => {
  return () => {
    const breakpointObserver = inject(BreakpointObserver);
    const router = inject(Router);

    const isMobile = breakpointObserver.isMatched([Breakpoints.Handset]);
    if (isMobile) {
      return true;
    } else {
      router.navigate([RouterPaths.LANDING]);
      return false;
    }
  };
};
